import { render } from "./Vioce.vue?vue&type=template&id=85d7a93e&scoped=true"
import script from "./Vioce.vue?vue&type=script&lang=js"
export * from "./Vioce.vue?vue&type=script&lang=js"

import "./Vioce.vue?vue&type=style&index=0&id=85d7a93e&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85d7a93e"]])

export default __exports__